const locale = {
    lang: {
        tonow: "就现在"
    }
};
export default locale;
